export default __webpack_public_path__ + "static/media/logo.9d12f19c.svg";